const env = process.env.NODE_ENV || "development";

const domainEnvironment = {
  development: {
        domainAdminSide: "http://localhost:3000",
        domainUserSide: "http://localhost:3001",
        domainName:"",
  },
  production: {
      domainAdminSide: "https://admin.ninhthuan.cgis.asia",
      domainUserSide: "https://ninhthuan.cgis.asia",
      domainName:"ninhthuan.cgis.asia",
  },
};

module.exports = domainEnvironment[env];
